/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

//import { off } from "process";
// 在文件顶部引入
import { marked } from 'marked';

// 配置 marked
marked.setOptions({
    breaks: true,          // 换行符转换为 <br>
    gfm: true,             // 启用 GitHub Flavored Markdown
    headerIds: false       // 不生成标题ID
});

let messageList = [];
/* global document, Office */

Office.onReady(async (info) => {
    const isAuthorized = await CHeckMailAuthorize();
     if (!isAuthorized) {
        
        document.getElementById('permissionDenied').style.display = 'block';
        return;
     }
  if (info.host === Office.HostType.Outlook) {
    //document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    document.getElementById("run").onclick = run;
    document.getElementById("AIZongJie").onclick = AIZongJie;
    document.getElementById("AIFenXi").onclick = AIFenXi;
    document.getElementById("HuiFu-Y").onclick = AIReply;
    document.getElementById("HuiFu-YA").onclick = AIReplyAll;
    document.getElementById("FanYi-Y").onclick = AIFanYi;
  }
   loadPreviousEmail(Office.context.mailbox.item.conversationId);
   InitLanguagePanel();
       const item = Office.context.mailbox.item;
    
    // 1. 获取发件人
    const fromRecipient = item.from;
    if (fromRecipient) {
        console.log("发件人:", fromRecipient.emailAddress);
        strFrom = fromRecipient.emailAddress;
    }
    
    // 2. 获取收件人(To)
    const toRecipients = item.to;
    if (toRecipients && toRecipients.length > 0) {
        toRecipients.forEach(recipient => {
            strTo += recipient.emailAddress + ";";
            console.log("收件人(To):", recipient.emailAddress);
        });
    }
    
    // 3. 获取抄送人(Cc)
    const ccRecipients = item.cc;
    if (ccRecipients && ccRecipients.length > 0) {
        ccRecipients.forEach(recipient => {
            strCc += recipient.emailAddress + ";";
            console.log("抄送人(Cc):", recipient.emailAddress);
        });
    }
});

function InitLanguagePanel() {
    // 编辑内容更新后重新初始化
    //document.getElementById('AIRunSe').innerHTML = '<span class="ms-Button-label">XXXX</span>'
    const languageSelector = document.getElementById('languageSelector');
    const languageSelector2 = document.getElementById('languageSelector2');
    if(BROWSER_LANGUAGE == 'zh-CN'){
       initLanguageSelector('2052',languageSelector);
       initLanguageSelector2('2052',languageSelector2);
    }else{
        initLanguageSelector('1033',languageSelector);
        initLanguageSelector2('1033',languageSelector2);
    }
}
/**
 * 保存邮件数据用于回复功能
 * 该函数获取当前邮件的关键信息并将其存储在本地存储中
 * 以便在撰写回复页面时能够引用这些信息
 */

export async function run() {
  /**
   * Insert your Outlook code here
   */
    //loadXML();
    clearAllCards(); 
}

//获取邮件正文
async function getEmailBody() {
    try {
        const item = Office.context.mailbox.item;
        
        // 使用 Promise 包装 getAsync
        const text = await new Promise((resolve, reject) => {
            item.body.getAsync("text", (result) => {
                if (result.status === Office.AsyncResultStatus.Succeeded) {
                    resolve(result.value);
                } else {
                    reject(new Error(`获取失败: ${result.error.message}`));
                }
            });
        });
        
        console.log("邮件纯文本内容:", text);
        return text; // ✅ 这个 return 会返回到调用者

    } catch (error) {
        console.error("获取邮件正文失败:", error);
        throw error; // ✅ 抛出错误，让调用者处理
    }
}

async function insertTextIntoBody(insertCont) {
    // 获取当前的撰写项目
    const item = Office.context.mailbox.item;
    
    // 设置插入的文本
    // const textToInsert = "这是要插入的文本内容";
    const textToInsert = insertCont;
    
    // 方法1：使用 setSelectedDataAsync
    Office.context.mailbox.item.body.setSelectedDataAsync(
        textToInsert,
        { coercionType: Office.CoercionType.Text }, // 或 Office.CoercionType.Html
        function(asyncResult) {
            if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                console.log("文本插入成功");
            } else {
                console.error("插入失败: " + asyncResult.error.message);
            }
        }
    );
}

async function insertTextIntoOutlookBody() {
    try {
        // 方法 1: 使用 Office.context.mailbox.item.body 的 API
        await Word.run(async (context) => {
            // 获取正文
            const body = context.mailbox.item.body;
            
            // 在光标位置插入文本
            body.insertText('这是插入的文本', Word.InsertLocation.end);
            
            await context.sync();
            console.log('文本插入成功');
        });
    } catch (error) {
        console.error('插入失败:', error);
    }
}

/**
 * 与 Dify AI 代理进行聊天查询
 * @param {string} agenttype - 代理类型
 * @param {string} content - 查询内容
 * @param {function} onProgress - 进度回调函数，接收流式响应片段
 * @returns {Promise<string>} 完整的响应内容
 */

/**
 * 使用示例
 */
 async function AIZongJie() {
    try {
        const agenttype = "1";
        const  query = await  getEmailBody();
        if(query == '')
        {
            showLoadingMailEmpty();
            return;
        }
        showLoading();
        // 使用 onProgress 回调实时显示流式输出
        const fullResponse = await chatQuery(agenttype, query, '','',(chunk) => {
            console.log('收到片段:', chunk);
            // 这里可以更新UI，比如将内容添加到聊天窗口
            document.getElementById('chat-output').innerText += chunk;
        });
         hideLoading(); 
        console.log('完整响应:', fullResponse);
        addWelcomeCard(fullResponse);
        messageList.push(fullResponse);
        saveEmailForReply(Office.context.mailbox.item.conversationId);
        return fullResponse;
        
    } catch (error) {
        console.error('聊天查询失败:', error);
        hideLoading();
        const errmesg = showTimeoutError();
        addWelcomeCard(errmesg);
        // 这里可以显示错误提示给用户
        // alert('助手回复出现错误，请重新尝试！');
    }
}
 async function AIFenXi() {
    try {
        const agenttype = "6";
        const  query = await  getEmailBody();
       if(query == '')
        {
            showLoadingMailEmpty();
            return;
        }
        showLoading();
        // 使用 onProgress 回调实时显示流式输出
        const fullResponse = await chatQuery(agenttype, query, '','',(chunk) => {
            console.log('收到片段:', chunk);
            // 这里可以更新UI，比如将内容添加到聊天窗口
            document.getElementById('chat-output').innerText += chunk;
        });
        hideLoading(); 
        console.log('完整响应:', fullResponse);
        addWelcomeCard(fullResponse);
        messageList.push(fullResponse);
        saveEmailForReply(Office.context.mailbox.item.conversationId);
        return fullResponse;
        
    } catch (error) {
        console.error('聊天查询失败:', error);
        hideLoading();
        const errmesg = showTimeoutError();
        addWelcomeCard(errmesg);
        // 这里可以显示错误提示给用户
        // alert('助手回复出现错误，请重新尝试！');
    }
}

async function AIReply() {
    const mailBody = await AIHuiFu();
    if(mailBody == '') return;
    const html = marked.parse(mailBody);
    // ✅ 单个零宽空格就够了      // 不需要点号，不需要删除操作
    const ZERO_WIDTH_SPACE = '​';

    Office.context.mailbox.item.displayReplyForm({
        'htmlBody': `${html}${ZERO_WIDTH_SPACE}` // 空的段落
    });
}
async function AIReplyAll() {
    const mailBody = await AIHuiFu();
    if(mailBody == '') return;
    const html = marked.parse(mailBody);
    // ✅ 单个零宽空格就够了      // 不需要点号，不需要删除操作
    const ZERO_WIDTH_SPACE = '​';

    Office.context.mailbox.item.displayReplyAllForm({
        'htmlBody': `${html}${ZERO_WIDTH_SPACE}` // 空的段落
    });
}
 async function AIHuiFu() {
    try {
        const agenttype = "5";
        const  query = await  getEmailBody();
        if(query == '')
        {
            showLoadingMailEmpty();
            document.getElementById('HuiFuBox').style.display = 'none';
            return "";
        }
        var languagelist = document.getElementById('languageSelector2')  // 下拉select元素
        const languagemark= languagelist.value;  // 选择的语种编号
        console.log(languagelist+'11111111111111'+languagemark);
        const languagetext= languagelist.querySelector(`option[value="${languagemark}"]`).text;  // 选择的语种
        document.getElementById('HuiFuBox').style.display = 'none';
        const require = document.getElementById('requirements').value;
        console.log('文本：'+require,'语种：'+languagetext,'mark：'+languagemark)
        // 使用 onProgress 回调实时显示流式输出
        showLoading();
        const fullResponse = await chatQuery(agenttype, query, languagetext,require, (chunk) => {
            console.log('收到片段:', chunk);
            // 这里可以更新UI，比如将内容添加到聊天窗口
            document.getElementById('chat-output').innerText += chunk;
        });
        hideLoading(); 
        console.log('完整响应:', fullResponse);
        addWelcomeCard(fullResponse);
        messageList.push(fullResponse);
        saveEmailForReply(Office.context.mailbox.item.conversationId);
        return fullResponse;
    } catch (error) {
        console.error('聊天查询失败:', error);
        hideLoading();
        const errmesg = showTimeoutError();
        addWelcomeCard(errmesg);
        // 这里可以显示错误提示给用户
        // alert('助手回复出现错误，请重新尝试！');
        return "";
    }
}
// AI翻译传参
async function AIFanYi() {
    try {
        const agenttype = "4";
        const kuanginfo= await getEmailBody();    // 框里的文本内容
        var cardinfo = window.cardcontent;
        if(cardinfo == undefined)
        {
            var query = kuanginfo
            if(query == '')
            {
                showLoadingMailEmpty();
                document.getElementById('FanYiBox').style.display = 'none';
                return;
            }
        }
        else
        {
            var query = cardinfo
        }
        var languagelist = document.getElementById('languageSelector');  // 下拉select元素
        const languagemark= languagelist.value;  // 选择的语种编号
        const languagetext= languagelist.querySelector(`option[value="${languagemark}"]`).text;  // 选择的语种
        console.log('文本：'+query,'语种：'+languagetext,'mark：'+languagemark);
        console.log(kuanginfo,cardinfo)
        document.getElementById('FanYiBox').style.display = 'none';
        
        // 使用 onProgress 回调实时显示流式输出
        showLoading();
        const fullResponse = await chatQuery(agenttype, query, languagetext,'', (chunk) => {
            console.log('收到片段:', chunk);
            // 这里可以更新UI，比如将内容添加到聊天窗口
            document.getElementById('chat-output').innerText += chunk;
        });
        hideLoading(); 
        window.cardcontent = undefined;
        console.log('完整响应:', fullResponse);
        addWelcomeCard(fullResponse);
        messageList.push(fullResponse);
       saveEmailForReply(Office.context.mailbox.item.conversationId);
        return fullResponse;
    } catch (error) {
        console.error('聊天查询失败:', error);
        hideLoading();
        const errmesg = showTimeoutError();
        addWelcomeCard(errmesg);
        // 这里可以显示错误提示给用户
        // alert('助手回复出现错误，请重新尝试！');
    }
}

function loadPreviousEmail(id) {
    console.log("loadPreviousEmail");
    if(id == null) return; 
        const emailData = JSON.parse(localStorage.getItem(id));
        console.log('从阅读页面获取的数据:', emailData);
        if (emailData == null) {
            console.log('没有找到之前的数据');
            return;
        }
        for (let i = 0; i < emailData.length; i++) {
            console.log('添加消息卡片:', emailData[i]);
            addWelcomeCard(emailData[i]);
            messageList.push(emailData[i]);
        }
  }

function saveEmailForReply(id) {
    console.log("saveEmailForReply");
     if(id == null) return; 
    // 保存到 localStorage
    localStorage.setItem(id, JSON.stringify(messageList));
}

// 添加欢迎卡片
function addWelcomeCard(fullResponse) {
// 创建一个只有复制和插入按钮的卡片
const simpleCard = addMessageCard({
    type: 'ai',
    content: fullResponse,
    time: new Date(),
    actions: ['translate']  // 只显示复制和插入按钮
});
}


// 创建操作按钮
function createActionButton(action, content) {
    // 清理但不转义
    const cleanContent = sanitizeLLMResponse(content);
    
    // 创建唯一ID
    const buttonId = `btn-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    var actions = {};
    if(BROWSER_LANGUAGE == 'zh-CN'){
        actions = {
            'translate': {  text: '📋 翻译',  color: '#0078d4'},
        };
    }else
    {
        actions = {
            'translate': {  text: '📋 Translate',  color: '#0078d4'},
        };
    }
    
    const config = actions[action];
    if (!config) return '';

    // 使用setTimeout确保DOM已存在
    setTimeout(() => {
        const button = document.getElementById(buttonId);
        if (button) {
            button.onclick = () => {
                handleCardFanyi(cleanContent, action);
            };
        }
    }, 0);

    return `
        <button id="${buttonId}"
                style="padding: 4px 8px; 
                       background: ${config.color}; 
                       color: white; 
                       border: none; 
                       border-radius: 4px; 
                       font-size: 11px; 
                       cursor: pointer;">
            ${config.text}
        </button>
    `;
}

window.handleCardFanyi = function(content, cardId) {
    console.log('翻译内容：:', content);
    document.getElementById("FanYiBox").style.display =  
    document.getElementById("FanYiBox").style.display === "block" ? "none" : "block";
    window.cardcontent = content
    console.log("全局翻译内容："+cardcontent)
};

function clearAllCards() {
    const container = document.getElementById('card-container');
    if (container) {
        container.innerHTML = '';
        messageList = [];
        saveEmailForReply(Office.context.mailbox.item.conversationId);
    }
}

function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}


// 添加CSS动画
const cardStyle = document.createElement('style');
cardStyle.textContent = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    
    @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
    }
`;
document.head.appendChild(cardStyle);

let isPaneOpen = true;

// 当用户点击功能区按钮关闭窗格时会触发
function monitorPaneClose() {
    // 方法1：检查DOM元素可见性
    const checkPane = setInterval(() => {
        const pane = document.querySelector('.office-panel');
        if (!pane || pane.style.display === 'none') {
            if (isPaneOpen) {
                console.log('任务窗格已关闭');
                onPaneClose();
                isPaneOpen = false;
            }
        } else {
            isPaneOpen = true;
        }
    }, 1000);
    
    window.addEventListener('unload', () => clearInterval(checkPane));
}

function onPaneClose() {
    // 执行清理操作
    console.log('执行关闭清理...111');
   // alert('执行关闭清理...111');

}


import xmlString from './ConfigFile/languagelist.xml';
function loadXML() {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");
    window.xmlData = xmlDoc;
    
    console.log('XML 加载成功');
    
    // 示例：获取数据
    const languages = xmlDoc.querySelectorAll('language');
    console.log(`找到 ${languages.length} 种语言`);
    //addWelcomeCard(languages);
    
    return xmlDoc;
}

// 添加消息卡片
function addMessageCard(data) {
    const container = document.getElementById('card-container');

    if (!container) return;
    
    // 创建卡片元素
    const card = document.createElement('div');
    card.className = `message-card ${data.type}-card`;
    card.innerHTML = createAICardHTML(data);
    container.appendChild(card);

    // 新增内容后自动滑动到最新的底部
    container.scrollTop = container.scrollHeight;
    
    return card;

    
}

// 辅助函数
function formatTime(date) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}
// 创建AI卡片HTML
function createAICardHTML(data) {
    const time = data.time ? formatTime(data.time) : formatTime(new Date());
    
    // 使用 marked 转换 Markdown
    const contentHTML = marked.parse(data.content || '正在思考...');
    
    let actionsHTML = '';
    if (data.actions && data.actions.length > 0) {
        actionsHTML = `
            <div style="margin-top: 12px; padding-top: 12px; border-top: 1px solid rgba(0,0,0,0.1);">
                <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                    ${data.actions.map(action => createActionButton(action, data.content)).join('')}
                </div>
            </div>
        `;
    }
    
    return `
        <div style="display: flex; align-items: flex-start; gap: 10px; margin-bottom: 16px;">
            <div style="width: 32px; height: 32px; background: linear-gradient(135deg, #3498db, #3498db); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; color: white; flex-shrink: 0;">
                AI
            </div>
            <div style="flex: 1; min-width: 0;">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                    <div style="font-weight: 600; font-size: 13px; color: #3498db;">AI 助手</div>
                    <div style="font-size: 11px; color: #605e5c;">${time}</div>
                </div>
                <div style="font-size: 14px; line-height: 1.5; color: #323130; overflow-wrap: break-word;">
                    ${contentHTML}
                </div>
                ${actionsHTML}
            </div>
        </div>
    `;
}
